import React, { Fragment, useEffect } from 'react'
import { Container, Row, Col, Card } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import useAuth from '../../context/auth/useAuth'
import { Link } from 'react-router-dom'
import { getOrdersClientToDelivery, removeOrder } from '../../actions/ordersActions'
import QRCode from "react-qr-code";
import Swal from 'sweetalert2'
import Version from '../../version'


export default function Ordersfordelivery() {
  	const { t } = useTranslation()
	const dispatch = useDispatch()
	const {client} = useAuth()

	const {orders} = useSelector(state=>state.orders)

	useEffect(() => {
		window.scrollTo({
            top:0,
            behavior: 'instant'
        })
		if(client){
			dispatch(getOrdersClientToDelivery(client?.id))
		}
	},[dispatch, t, client])

	const deleteOrder = (order) => {
		Swal.fire({
			showConfirmButton: true,
			showCancelButton: true,
			confirmButtonText: t('global.yes'),
			cancelButtonText: t('global.no'),
			icon: 'warning',
			text: t('client.orders.areyousuredelete')
		}).then(result => {
			if (result.isConfirmed) {
				dispatch(removeOrder(order._id))
			}
		})
	}

	return (
        <Container className='px-sm-4 px-md-5'>
            <Row className="mb-3">
                <Col xs={2} className='p-sm-2 p-md-0'>
                    <Link className="p-0 my-3" to="/client/dashboard">
                        <img src="../images/arrow-back.svg" alt="arrow-back" width={25}></img>
                    </Link>
                </Col>
                <Col xs={8} className='text-center'>
                    <h1>{t('admin.orders.ordersfordelivery')}</h1>
                </Col>
                <Col xs={2}></Col>
            </Row>
			<Row className="text-start my-3">
				<Col>
                {orders?.length > 0
                    ?
						orders?.map((order, index) =>(
							<Card key={index} className='my-2'>
								<Card.Header>
									<Row>
										<Col className="text-start">
											<h2>{t('admin.orders.restaurant')}</h2>
											<h2 className='fw-bold'>{order?.restaurant}</h2>
											<div>
												<strong>{t('admin.orders.hour')}<br/>
												{order?.hour+' - '+order?.date?.substr(8,2)+'/'+order?.orderAt?.substr(5,2)+'/'+order?.orderAt?.substr(0,4)}
												</strong>
											</div>
										</Col>
										<Col className="text-end">
											<div>
												<strong>
													{order?.orderAt?.substr(11,5)}<br/>
													{order?.orderAt?.substr(8,2)+'/'+order?.orderAt?.substr(5,2)+'/'+order?.orderAt?.substr(0,4)}
												</strong>
											</div>
											<h2 className="mb-0 fw-bold">{t('admin.orders.order')}</h2>
											<h3 className='fw-bold'>{order?.orderReference}</h3>
											<h3 className='fw-bold'>{t('client.menus.totalpay')}: {order?.price} €</h3>
										</Col>
									</Row>
								</Card.Header>
								<Card.Body className='text-center'>
									{
										order.isPaid
											?
												<></>
											:
												<Col className='d-flex justify-content-end'>
													<button onClick={() => deleteOrder(order)} className='btn btn-secondary p-2'><i className="fas fa-trash"></i></button>
												</Col>
									}
									{order?.firstdish?.name && <>{t('admin.orders.firstdish')}<br/><h3 className="text-uppercase fw-bold">{order?.firstdish?.name}</h3></>}
									{order?.seconddish?.name && <>{t('admin.orders.seconddish')}<br/><h3 className="text-uppercase fw-bold">{order?.seconddish?.name}</h3></>}
									{order?.drink?.name && <>{t('admin.orders.drink')}<br/><h3 className="text-uppercase fw-bold">{order?.drink?.name}</h3></>}
									{order?.dessert?.name && <>{t('admin.orders.dessert')}<br/><h3 className="text-uppercase fw-bold">{order?.dessert?.name}</h3></>}
									{order?.complements?.length > 0 &&
										<Fragment>
											{t('admin.orders.complements')}<br/>
											{order?.complements?.map((complement, index) =>(
												<Fragment key={index}><h3 className='text-uppercase fw-bold'>{complement?.name}</h3></Fragment>
											))}
										</Fragment>
									}
									<br/>
									{
										order.isPaid
											?
												<QRCode value={'/kitchen/order/' + order?._id}/>
											:
												<Row>
													<Col>
														<Link to={"/client/order/"+ order?._id} className='btn btn-primary p-2'>{t("admin.orders.gotopay")}</Link>
													</Col>
												</Row>
									}
								</Card.Body>
							</Card>
						))
					:
						<></>
				}
				</Col>
			</Row>
			<Row>
                <Col className='text-center mt-2'>
                    <Version />
                </Col>
            </Row>
        </Container>
	)
}